import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { ShoppingBag, User, Menu, X } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

const LINKS = [
  { to: "/shop", label: "Shop" },
  { to: "/shop?collection=pulse", label: "Pulse" },
  { to: "/shop?collection=core", label: "Core" },
  { to: "/shop?collection=accessories", label: "Accessories" },
  { to: "/story", label: "Story" },
  { to: "/track-order", label: "Track Order" },
];

export default function Navbar() {
  const { count, setOpen } = useCart();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [mobile, setMobile] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "backdrop-blur-xl bg-ink/70 border-b border-border/60" : "bg-transparent"
      }`}
    >
      <nav className="container-sync flex items-center justify-between h-20">
        <Link to="/" data-testid="logo-link">
          <Logo variant="full" size="md" asLink={false} />
        </Link>

        <div className="hidden lg:flex items-center gap-10">
          {LINKS.map((l) => (
            <Link key={l.label} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-chalk/80 hover:text-chalk link-underline">
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-5">
          <button data-testid="account-btn" onClick={() => navigate(user ? "/account" : "/login")}
            className="text-chalk/80 hover:text-pulse transition-colors" aria-label="Account">
            <User size={20} strokeWidth={1.5} />
          </button>
          <button data-testid="cart-btn" onClick={() => setOpen(true)}
            className="relative text-chalk/80 hover:text-pulse transition-colors" aria-label="Cart">
            <ShoppingBag size={20} strokeWidth={1.5} />
            {count > 0 && (
              <span data-testid="cart-count"
                className="absolute -top-2 -right-2 bg-pulse text-ink text-[10px] font-mono w-4 h-4 flex items-center justify-center">
                {count}
              </span>
            )}
          </button>
          <button className="lg:hidden text-chalk" onClick={() => setMobile((v) => !v)}
            data-testid="mobile-menu-btn" aria-label="Menu">
            {mobile ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </nav>

      {mobile && (
        <div className="lg:hidden bg-ink border-t border-border/60 px-6 py-6 flex flex-col gap-5" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <Link key={l.label} to={l.to} onClick={() => setMobile(false)}
              className="font-mono text-sm uppercase tracking-[0.2em] text-chalk/80">
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}
